import React, {useEffect, useState} from 'react';
import {fetchH2h, fetchH2hAll, fetchH2hAllStats} from "../../../api";
import dayjs from "dayjs";
import winIcon from '../../../assets/icons/compare-win.png'
import loseIcon from '../../../assets/icons/compare-lose.png'
import drawIcon from '../../../assets/icons/compare-draw.png'
import noTeamLogo from "../../../assets/icons/noTeamLogo.png";
import Box from "@mui/material/Box";
import {styled} from "@mui/material";
import LinearProgress, {linearProgressClasses} from "@mui/material/LinearProgress";
import cp1 from '../../../assets/icons/comparison1.png'
import cp2 from '../../../assets/icons/comparison2.png'
import cp3 from '../../../assets/icons/comparison3.png'

function Compare(props) {
    const {matchTeamsDetail, matchId, lang} = props;

    const [h2hData, setH2hData] = useState(null);
    const [h2hAllData, setH2hAllData] = useState(null);
    const [h2hAllStatsData, setH2hAllStatsData] = useState(null);

    useEffect(() => {
        fetchH2h(matchId).then(data => {
            setH2hData(data.data.data);
        })

        fetchH2hAll(matchId).then(data => {
            setH2hAllData(data.data.data);
        })

        fetchH2hAllStats(matchId).then(data => {
            setH2hAllStatsData(data.data.data);
        })
    }, []);

    console.log('h2hAllStatsData', h2hAllStatsData);

    const date = value => {
        return dayjs(value).format('DD.MM');
    };

    const dateForH2h = value => {
        return dayjs(value).format('DD.MM.YYYY');
    };

    const matchResultForTeam = (match, titleId) => {
        if (match.homeId === titleId) {
            if (match.hscore > match.ascore) {
                return winIcon
            } else if (match.hscore < match.ascore) {
                return loseIcon
            } else {
                return drawIcon
            }
        } else {
            if (match.hscore < match.ascore) {
                return winIcon
            } else if (match.hscore > match.ascore) {
                return loseIcon
            } else {
                return drawIcon
            }
        }
    };

    const h2hMatchesTeamStyle = (data) => {
        if (matchTeamsDetail?.homeId === data.homeId) {
            if (data.hscore > data.ascore) {
                return 'match-detail-h2h-home-win'
            } else if (data.ascore > data.hscore) {
                return 'match-detail-h2h-normal-team-style'
            } else if (data.ascore === data.hscore) {
                return 'match-detail-h2h-draw'
            }
        } else if (matchTeamsDetail?.awayId === data.homeId) {
            if (data.hscore > data.ascore) {
                return 'match-detail-h2h-away-win'
            } else if (data.ascore > data.hscore) {
                return 'match-detail-h2h-normal-team-style'
            } else if (data.ascore === data.hscore) {
                return 'match-detail-h2h-draw'
            }
        }
    }
    const h2hMatchesTeamStyleAway = (data) => {
        if (matchTeamsDetail?.awayId === data.awayId) {
            if (data.ascore > data.hscore) {
                return 'match-detail-h2h-away-win'
            } else if (data.hscore > data.ascore) {
                return 'match-detail-h2h-normal-team-style'
            } else if (data.ascore === data.hscore) {
                return 'match-detail-h2h-draw'
            }
        } else if (matchTeamsDetail?.awayId === data.homeId) {
            if (data.ascore > data.hscore) {
                return 'match-detail-h2h-home-win'
            } else if (data.ascore > data.hscore) {
                return 'match-detail-h2h-normal-team-style'
            } else if (data.ascore === data.hscore) {
                return 'match-detail-h2h-draw'
            }
        }
    }

    const onImageError = (e) => {
        e.target.src = noTeamLogo;
    }

    const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
        height: 10,
        borderRadius: 1,
        width: 50,
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 1,
        },
    }));

    const comparisonCalc = (perc) => {
        if (perc === 0) {
            return {
                flex: 0.009
            }
        } else {
            return {
                flex: perc / 10
            }
        }
    }

    return (
        <div>
            <div>
                {/*PREVIOUS MATCHES*/}
                <div>
                    {
                        lang === 'tr' ?
                            <div className='h2h-table-titles'>Aralarındaki Maçlar</div>
                            :
                            <div className='h2h-table-titles'>Previous Matches</div>
                    }

                    {
                        h2hAllStatsData &&
                            <div style={{display: 'flex', width: '100%'}}>
                                {/*ALL MATCHES*/}
                                <div className='prev-matches-tables-container'>
                                    <div className='match-detail-all-matches-table'>
                                        Tüm Maçlar
                                    </div>
                                    <div className='match-detail-percent-row'>
                                        <span className='all-matches-side comp1-team'>{matchTeamsDetail?.home}</span>
                                        {/*<div className='all-matches-side-percent'>{h2hAllStatsData?.homeWinsPercent}</div>*/}
                                        <div className='comparison-general-container'>
                                            <div style={comparisonCalc(h2hAllStatsData?.all?.homeWinsPercent)} className='comp1'></div>
                                        </div>
                                        <div>{h2hAllStatsData?.all?.homeWins}</div>
                                    </div>
                                    <div className='match-detail-percent-row'>
                                        <span className='all-matches-side comp3-team'>Beraberlik</span>
                                        {/*<div className='all-matches-side-percent'>{h2hAllStatsData?.drawsPercent}</div>*/}
                                        <div className='comparison-general-container'>
                                            <div style={comparisonCalc(h2hAllStatsData?.all?.drawsPercent)} className='comp2'></div>
                                        </div>
                                        <div>{h2hAllStatsData?.all?.draws}</div>
                                    </div>
                                    <div className='match-detail-percent-row'>
                                        <span className='all-matches-side comp2-team'>{matchTeamsDetail?.away}</span>
                                        {/*<div className='all-matches-side-percent'>{h2hAllStatsData?.awayWinsPercent}</div>*/}
                                        <div className='comparison-general-container'>
                                            <div style={comparisonCalc(h2hAllStatsData?.all?.awayWinsPercent)} className='comp3'></div>
                                        </div>
                                        <div>{h2hAllStatsData?.all?.awayWins}</div>
                                    </div>
                                </div>

                                {/*HOME MATCHES*/}
                                <div className='prev-matches-tables-container'>
                                    <div className='match-detail-all-matches-table'>
                                        {matchTeamsDetail.home} Evindeki Maçlar
                                    </div>
                                    <div className='match-detail-percent-row'>
                                        <span className='all-matches-side comp1-team'>{matchTeamsDetail.home}</span>
                                        <div className='comparison-general-container'>
                                            <div style={comparisonCalc(h2hAllStatsData?.home?.homeWinsPercent)} className='comp1'></div>
                                        </div>
                                        <div>{h2hAllStatsData?.home?.homeWins}</div>
                                    </div>
                                    <div className='match-detail-percent-row'>
                                        <span className='all-matches-side comp3-team'>Beraberlik</span>
                                        <div className='comparison-general-container'>
                                            <div style={comparisonCalc(h2hAllStatsData?.home?.drawsPercent)} className='comp2'></div>
                                        </div>
                                        <div>{h2hAllStatsData?.home?.draws}</div>
                                    </div>
                                    <div className='match-detail-percent-row'>
                                        <span className='all-matches-side comp2-team'>{matchTeamsDetail.away}</span>
                                        <div className='comparison-general-container'>
                                            <div style={comparisonCalc(h2hAllStatsData?.home?.awayWinsPercent)} className='comp3'></div>
                                        </div>
                                        <div>{h2hAllStatsData?.home?.awayWins}</div>
                                    </div>
                                </div>
                            </div>
                    }

                    <div className='match-detail-h2h-table-header-container'>
                        <div>Tarih</div>
                        <div></div>
                        <div>Maç</div>
                        <div></div>
                        <div>İY</div>
                    </div>
                    {
                        h2hData &&
                        h2hData.h2hMatches?.map((data, index) => {
                            return (
                                <div className='only-h2h-row-section'
                                     style={{background: index % 2 === 0 ? '#ffffff' : '#f1f1f1'}}>
                                    <div>
                                        <span
                                            className='match-detail-compare-date'>{dateForH2h(data.dateTimeUtc)}</span>
                                    </div>

                                    <div
                                        onClick={() => {
                                            window.open(`/team-detail/${matchTeamsDetail?.homeId}`)
                                        }}
                                        className='h2h-home-team-container'>
                                        <span className={h2hMatchesTeamStyle(data)}>
                                            {data.home}
                                        </span>
                                    </div>

                                    <div className='h2h-score'>
                                        <span
                                            className='match-detail-compare-score'>{data.hscore} - {data.ascore}</span>
                                    </div>

                                    <div
                                        onClick={() => {
                                            window.open(`/team-detail/${matchTeamsDetail?.awayId}`)
                                        }}
                                        className='h2h-away-team-container'>
                                        <span className={h2hMatchesTeamStyleAway(data)}>
                                            {data.away}
                                        </span>
                                    </div>

                                    <div className='h2h-p1-score'>
                                        <span
                                            className='match-detail-compare-first-period-score'>{data.hp1} - {data.ap1}</span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>

                {/*HOME MATCHES*/}
                <div className='match-detail-compare-form-tables-section'>
                    <div className='match-detail-compare-form-table'>
                        {
                            lang === 'tr' ?
                                <div className='match-detail-compare-form-team-row-container'>
                                    <img className="match-detail-teams-form-logo"
                                         src={`https://d17jyjgv9729qk.cloudfront.net/assets/img/m/teams/${matchTeamsDetail?.homeId}.png`}
                                         onError={(e) => onImageError(e)}
                                         alt=""/>
                                    <div className='form-table-titles'>{matchTeamsDetail?.home} - Form Durumu</div>
                                </div>
                                :
                                <div className='match-detail-compare-form-team-row-container'>
                                    <img className="match-detail-teams-form-logo"
                                         src={`https://d17jyjgv9729qk.cloudfront.net/assets/img/m/teams/${matchTeamsDetail?.homeId}.png`}
                                         onError={(e) => onImageError(e)}
                                         alt=""/>
                                    <div className='form-table-titles'>{matchTeamsDetail?.home} - Form</div>
                                </div>
                        }
                        {
                            h2hData &&
                            h2hData.homeMatches?.map((data, index) => {
                                return (
                                    <div className='h2h-row-section'
                                         style={{background: index % 2 === 0 ? '#ffffff' : '#f1f1f1'}}>
                                        <div>
                                            <span className='match-detail-compare-date'>{date(data.dateTimeUtc)}</span>
                                        </div>

                                        <div
                                            onClick={() => {
                                                window.open(`/team-detail/${data.homeId}`)
                                            }}
                                            className='h2h-home-team-container'>
                                        <span
                                            style={{color: matchTeamsDetail?.homeId === data.homeId ? '#C63' : '#0C3A7E'}}>{data.home}</span>
                                        </div>

                                        <div className='h2h-score'>
                                            <span
                                                className='match-detail-compare-score'>{data.hscore} - {data.ascore}</span>
                                        </div>

                                        <div
                                            onClick={() => {
                                                window.open(`/team-detail/${data.awayId}`)
                                            }}
                                            className='h2h-away-team-container'>
                                            <span
                                                style={{color: matchTeamsDetail?.homeId === data.homeId ? '#0C3A7E' : '#C63'}}>{data.away}</span>
                                        </div>

                                        {/*<div className='h2h-p1-score'>
                                            <span className='match-detail-compare-first-period-score'>HT: {data.hp1} - {data.ap1}</span>
                                        </div>*/}

                                        <div className='match-detail-compare-status-icon-container'>
                                            <img src={matchResultForTeam(data, matchTeamsDetail?.homeId)} alt=""/>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    {/*AWAY MATCHES*/}
                    <div className='match-detail-compare-form-table'>
                        {
                            lang === 'tr' ?
                                <div className='match-detail-compare-form-team-row-container'>
                                    <img className="match-detail-teams-form-logo"
                                         src={`https://d17jyjgv9729qk.cloudfront.net/assets/img/m/teams/${matchTeamsDetail?.awayId}.png`}
                                         onError={(e) => onImageError(e)}
                                         alt=""/>
                                    <div className='form-table-titles'>{matchTeamsDetail?.away} - Form Durumu</div>
                                </div>
                                :
                                <div className='match-detail-compare-form-team-row-container'>
                                    <img className="match-detail-teams-form-logo"
                                         src={`https://d17jyjgv9729qk.cloudfront.net/assets/img/m/teams/${matchTeamsDetail?.awayId}.png`}
                                         onError={(e) => onImageError(e)}
                                         alt=""/>
                                    <div className='form-table-titles'>{matchTeamsDetail?.away} - Form</div>
                                </div>
                        }
                        {
                            h2hData &&
                            h2hData.awayMatches?.map((data, index) => {
                                return (
                                    <div className='h2h-row-section'
                                         style={{background: index % 2 === 0 ? '#ffffff' : '#f1f1f1'}}>
                                        <div>
                                            <span className='match-detail-compare-date'>{date(data.dateTimeUtc)}</span>
                                        </div>

                                        <div
                                            onClick={() => {
                                                window.open(`/team-detail/${data.homeId}`)
                                            }}
                                            className='h2h-home-team-container'>
                                        <span
                                            style={{color: matchTeamsDetail?.awayId === data.awayId ? '#0C3A7E' : '#C63'}}>{data.home}</span>
                                        </div>

                                        <div className='h2h-score'>
                                            <span
                                                className='match-detail-compare-score'>{data.hscore} - {data.ascore}</span>
                                        </div>

                                        <div
                                            onClick={() => {
                                                window.open(`/team-detail/${data.awayId}`)
                                            }}
                                            className='h2h-away-team-container'>
                                            <span
                                                style={{color: matchTeamsDetail?.awayId === data.awayId ? '#C63' : '#0C3A7E'}}>{data.away}</span>
                                        </div>

                                        {/*<div className='h2h-p1-score'>
                                            <span className='match-detail-compare-first-period-score'>HT: {data.hp1} - {data.ap1}</span>
                                        </div>*/}

                                        <div className='match-detail-compare-status-icon-container'>
                                            <img src={matchResultForTeam(data, matchTeamsDetail?.awayId)} alt=""/>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                {/*HHOME MATCHES*/}
                <div className='match-detail-compare-form-tables-section'>
                    <div className='match-detail-compare-form-table'>
                        {
                            lang === 'tr' ?
                                <div className='match-detail-compare-form-team-row-container'>
                                    <img className="match-detail-teams-form-logo"
                                         src={`https://d17jyjgv9729qk.cloudfront.net/assets/img/m/teams/${matchTeamsDetail?.homeId}.png`}
                                         onError={(e) => onImageError(e)}
                                         alt=""/>
                                    <div className='form-table-titles'>{matchTeamsDetail?.home} - İç Saha Form Durumu
                                    </div>
                                </div>
                                :
                                <div className='match-detail-compare-form-team-row-container'>
                                    <img className="match-detail-teams-form-logo"
                                         src={`https://d17jyjgv9729qk.cloudfront.net/assets/img/m/teams/${matchTeamsDetail?.homeId}.png`}
                                         onError={(e) => onImageError(e)}
                                         alt=""/>
                                    <div className='form-table-titles'>{matchTeamsDetail?.home} - Home</div>
                                </div>
                        }
                        {
                            h2hData &&
                            h2hData.homeHMatches?.map((data, index) => {
                                return (
                                    <div className='h2h-row-section'
                                         style={{background: index % 2 === 0 ? '#ffffff' : '#f1f1f1'}}>
                                        <div>
                                            <span className='match-detail-compare-date'>{date(data.dateTimeUtc)}</span>
                                        </div>

                                        <div
                                            onClick={() => {
                                                window.open(`/team-detail/${data.homeId}`)
                                            }}
                                            className='h2h-home-team-container'>
                                        <span
                                            style={{color: matchTeamsDetail?.homeId === data.homeId ? '#C63' : '#0C3A7E'}}>{data.home}</span>
                                        </div>

                                        <div className='h2h-score'>
                                            <span
                                                className='match-detail-compare-score'>{data.hscore} - {data.ascore}</span>
                                        </div>

                                        <div
                                            onClick={() => {
                                                window.open(`/team-detail/${data.awayId}`)
                                            }}
                                            className='h2h-away-team-container'>
                                            <span
                                                style={{color: matchTeamsDetail?.homeId === data.homeId ? '#0C3A7E' : '#C63'}}>{data.away}</span>
                                        </div>

                                        {/*<div className='h2h-p1-score'>
                                            <span className='match-detail-compare-first-period-score'>HT: {data.hp1} - {data.ap1}</span>
                                        </div>*/}

                                        <div className='match-detail-compare-status-icon-container'>
                                            <img src={matchResultForTeam(data, matchTeamsDetail?.homeId)} alt=""/>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    {/*AAWAY MATCHES*/}
                    <div className='match-detail-compare-form-table'>
                        {
                            lang === 'tr' ?
                                <div className='match-detail-compare-form-team-row-container'>
                                    <img className="match-detail-teams-form-logo"
                                         src={`https://d17jyjgv9729qk.cloudfront.net/assets/img/m/teams/${matchTeamsDetail?.awayId}.png`}
                                         onError={(e) => onImageError(e)}
                                         alt=""/>
                                    <div className='form-table-titles'>{matchTeamsDetail?.away} - Dış Saha Form Durumu
                                    </div>
                                </div>
                                :
                                <div className='match-detail-compare-form-team-row-container'>
                                    <img className="match-detail-teams-form-logo"
                                         src={`https://d17jyjgv9729qk.cloudfront.net/assets/img/m/teams/${matchTeamsDetail?.awayId}.png`}
                                         onError={(e) => onImageError(e)}
                                         alt=""/>
                                    <div className='form-table-titles'>{matchTeamsDetail?.away} - Away</div>
                                </div>
                        }
                        {
                            h2hData &&
                            h2hData.awayAMatches?.map((data, index) => {
                                return (
                                    <div className='h2h-row-section'
                                         style={{background: index % 2 === 0 ? '#ffffff' : '#f1f1f1'}}>
                                        <div>
                                            <span className='match-detail-compare-date'>{date(data.dateTimeUtc)}</span>
                                        </div>

                                        <div
                                            onClick={() => {
                                                window.open(`/team-detail/${data.homeId}`)
                                            }}
                                            className='h2h-home-team-container'>
                                        <span
                                            style={{color: matchTeamsDetail?.awayId === data.awayId ? '#0C3A7E' : '#C63'}}>{data.home}</span>
                                        </div>

                                        <div className='h2h-score'>
                                            <span
                                                className='match-detail-compare-score'>{data.hscore} - {data.ascore}</span>
                                        </div>

                                        <div
                                            onClick={() => {
                                                window.open(`/team-detail/${data.awayId}`)
                                            }}
                                            className='h2h-away-team-container'>
                                            <span
                                                style={{color: matchTeamsDetail?.awayId === data.awayId ? '#C63' : '#0C3A7E'}}>{data.away}</span>
                                        </div>

                                        {/*<div className='h2h-p1-score'>
                                            <span className='match-detail-compare-first-period-score'>HT: {data.hp1} - {data.ap1}</span>
                                        </div>*/}

                                        <div className='match-detail-compare-status-icon-container'>
                                            <img src={matchResultForTeam(data, matchTeamsDetail?.awayId)} alt=""/>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Compare;
